export default __webpack_public_path__ + "static/N0089-0cccb17df754f2db1f328999284e071e.png";